// extracted by mini-css-extract-plugin
module.exports = {"wrap":"JP","subtitle":"KP","contentWrap":"LP","imgWrap":"MP","heading":"NP","copy":"OP"};